export default "__VITE_ASSET__CbBPrhkV__"